import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";
import es from "./es";
import { startAutoTranslate } from "@/lib/autoTranslate";

const initialLang = localStorage.getItem("scenta-hq-lang") || "en";

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: initialLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

// Kick the DOM-wide auto-translator when the app boots so pages we haven't
// keyed with useTranslation() still translate.
if (typeof window !== "undefined") {
  const boot = () => startAutoTranslate(initialLang);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
}

export function setLanguage(lng: "en" | "es") {
  localStorage.setItem("scenta-hq-lang", lng);
  void i18n.changeLanguage(lng);
  startAutoTranslate(lng);
}

export default i18n;
